module.exports = __webpack_public_path__ + "c39cb48.woff2";